/**
 * Created by fgallucci on 17/06/2020.
 */

import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getWorkingTablesFromIstanceID } from 'App/actions'
import { resetSidebarStore } from 'src/App/actions'
import { mapWorkingTableWithT } from 'src/App/utils'
import { appConfigStore, sidebarStore } from 'services/state'
import { orderBy } from 'lodash'
import { Prompt } from 'react-router-dom'
import { GENERAL_CONFIG } from 'pages/InputView/constants'

function WorkingTables({ history, location, match }) {
  const { url, params } = match
  const { instanceId } = params
  const [wtData, setWtData] = useState()
  const { t } = useTranslation(['Shell', 'ImportLog'])
  const models = appConfigStore.get((store) => store.models)
  const isDragMode = sidebarStore.get((store) => store.drag)
  const { exportAllowed } = models[GENERAL_CONFIG] || {}

  // Do not refetch needlessly when changing language
  useEffect(() => {
    if (models) {
      // assert to avoid double refresh
      getWorkingTablesFromIstanceID(instanceId).then(setWtData)
    }
  }, [instanceId, models])

  useEffect(() => {
    if (!wtData) return

    const { wts, wtCounts } = wtData

    const mapWorkingTable = mapWorkingTableWithT(t, exportAllowed, models)

    // add order prop of model to wt by type
    const wtsWithOrderProp = wts.map((wt) => ({
      ...wt,
      order: models[wt.type]?.order
    }))

    const orderedWts = orderBy(wtsWithOrderProp, 'order')

    const WTs = orderedWts.map((wt) =>
      mapWorkingTable(wt, wtCounts, instanceId)
    )
    sidebarStore.set({ type: 'workingTables', items: WTs, drag: false })

    // If url and location.pathname are the same
    // we are not showing a working table detail yet.
    if (url === location.pathname && WTs.length) {
      // Open the first available WT
      history.replace(WTs[0].href)
    }
  }, [wtData, t, models])

  useEffect(() => {
    return resetSidebarStore
  }, [])

  // useEffect(() => {
  //   return history.listen((location) => {
  //     console.log('You changed the page to: ', location)
  //   })
  // }, [history])

  return isDragMode ? (
    <Prompt when={isDragMode} message={t('Shell:AreYouSure')} />
  ) : null
}

export default React.memo(WorkingTables)
